import Agent, {
  type AgentInstances,
  type AgentParams,
  type AgentSuggestions,
} from './Agent';

// Default agent that is used when no other agent is specified. Provides
// generic LLM functionality with Aha! tools.
class AppPrototypeAgent extends Agent {
  static name = 'AppPrototypeAgent';

  static publicName = 'Prototype';

  static available(
    _agentParams: AgentParams,
    _agentInstances: AgentInstances
  ): boolean {
    return window.currentAccount?.hasGeneralAiAssistant || false;
  }

  isReasoningEnabledByDefault(): boolean {
    return true;
  }

  getSuggestions(): AgentSuggestions {
    return [
      {
        title: 'User journey',
        prompt:
          'Tell me what type of experience you want to define and the number of steps that are part of it. You can refer to existing Aha! records by their ID.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a user journey.\n\nBefore starting though determine if I have explained who the user is. If not, ask. And before starting determine if I have provided enough detail about the journey. If not, ask.\nUse numbered steps starting from 1 to define the journey.\nLet's start...\n\nThe journey is: `,
        icon: 'list',
      },
      {
        title: 'Interface',
        prompt:
          'Tell me what kind of software you are building and how users will interact with it.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a software user interface.\n\nBefore starting though determine if I have explained who the user is. If not, ask. And before starting determine if I have provided enough detail about how the user will interact with the software. If not, ask.\nLet's start...\n\nThe user interface is: `,
        icon: 'whiteboard',
      },
      {
        title: 'Website',
        prompt:
          'Tell me what the purpose of your site is and describe the core pages.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a website.\n\nBefore starting though determine if I have explained who the user or users are. If not, ask. And before starting determine if I have provided enough detail about the core pages of the website. If not, ask.\nLet's start...\n\nThe website is: `,
        icon: 'refine',
      },
      {
        title: 'Workflow',
        prompt:
          'Tell about the structured sequence of steps and what users should accomplish.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a user workflow.\n\nBefore starting though determine if I have explained who the user is. If not, ask. And before starting determine if I have provided enough detail about the tasks the user needs to complete. If not, ask.\nUse numbered steps starting from 1 to define the journey.\nLet's start...\n\nThe workflow is: `,
        icon: 'draft',
      },
      {
        title: 'Wireframe',
        prompt:
          'Tell me about the basic structure, layout, and elements of the page.',
        prefix: `Here is what I want the AI assistant to do.\n\n-> I am going to ask you to create a wireframe.\n\nBefore starting though determine if I have explained who the user or users are. If not, ask. And before starting determine if I have provided enough detail about the core components of the wireframe. If not, ask.\nLet's start...\n\nThe wireframe is: `,
        icon: 'summarize',
      },
    ];
  }
}
Agent.register(AppPrototypeAgent);
